import HTTP from "@/_helpers/http";
import { TRANSACTIONS__API } from "@/_helpers/urls";
import { TRANSACTIONS__MUTATIONS } from "../mutation-types";
import { TRANSACTIONS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  dashboardinternaltransfers: [],
  internaltransfers: [],
  totalCount: 0,
  paymentMethods: [],
  isLoading: false,
  isIntxLoading: false,
  transferAmount: 0,
  range: null,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [TRANSACTIONS__MUTATIONS.TRXINTERNALTRANSFER](state, data) {
    state.internaltransfers = data?.data?.summaries
    state.totalCount = data?.data?.summaries?.length;
    state.paymentMethods = data?.data?.paymentMethods;
    state.transferAmount = data?.data?.transferAmount;
    state.pagination = data?.data?.pagination;
    state.range = data?.data?.range || null
  },
  [TRANSACTIONS__MUTATIONS.TRXDASHBOARDINTERNALTRANSFER](state, data) {
    state.dashboardinternaltransfers = data?.data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  SET_INTX_LOADING(state, data) {
    state.isIntxLoading = data;
  },
};

// Actions
const actions = {
  async [TRANSACTIONS__ACTIONS.TRXINTERNALTRANSFER](
    { commit, state },
    parameter = {}
  ) {
    try {
      commit("SET_LOADING", true);

      const {
        method_name,
        duration,
        status,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(method_name && { method_name }),
        ...(duration && { duration }),
        ...(status && { status }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${TRANSACTIONS__API.TRXINTERNALTRANSFER}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(TRANSACTIONS__MUTATIONS.TRXINTERNALTRANSFER, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTIONS__ACTIONS.TRXDASHBOARDINTERNALTRANSFER](
    { commit, state }
  ) {
    try {
      commit("SET_INTX_LOADING", true);

      const response = await HTTP().get(TRANSACTIONS__API.TRXDASHBOARDINTERNALTRANSFER);

      commit(
        TRANSACTIONS__MUTATIONS.TRXDASHBOARDINTERNALTRANSFER,
        response.data
      );
      commit("SET_INTX_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](
    { state, commit, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().patch(
        TRANSACTIONS__API.UPDATEDEPOSIT,
        parameter
      );
      await dispatch(TRANSACTIONS__MUTATIONS.TRXINTERNALTRANSFER);
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
